import React, { useState } from "react";
import "./css/LoginScreen.css"; // Import the CSS file

function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const universitiesLogos = `${process.env.PUBLIC_URL}/universitiesLogos.png`;

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        "https://dx223g37f76kajalf43fhzgcwe0lbbtv.lambda-url.eu-central-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ username, password }),
        }
      );

      if (!response.ok) {
        throw new Error("Invalid username or password");
      }
      onLogin(true);
      setUsername("");
      setPassword("");
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <main className="login-main">
        <div className="login-card">
          <div className="login-header">
            <h2>Login</h2>
            <p>Welcome to the Data Bank Website! Please login to continue.</p>
          </div>
          <form className="login-form" onSubmit={handleLogin}>
            <input
              className="login-input"
              type="text"
              placeholder="Username"
              aria-label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
            <input
              className="login-input"
              type="password"
              placeholder="Password"
              aria-label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            {error && (
              <p className="login-error" role="alert">
                {error}
              </p>
            )}
            <button
              className="btn btn-primary btn-block login-submit"
              type="submit"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </main>

      <footer className="login-footer">
        <img
          src={universitiesLogos}
          alt="Ben-Gurion University of the Negev and The Hebrew University of Jerusalem"
          className="login-logos"
        />
      </footer>
    </div>
  );
}

export default LoginScreen;
